import React from "react"
import TitleSection from "../title-section";
import { ReferenciaContenido } from '../../../interfaces/ReferenciaContenido';
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import './alliesLogos.scss'

const AlliesLogos = (props : ReferenciaContenido) => {
    const blockName: string = "m-allies-logos";

    return(
        <section className={blockName}>
            <div className={`${blockName}__information`}>
                <TitleSection title={props.tituloGeneral} />
                {props.descripcion && documentToReactComponents(props.descripcion.json)}
            </div>
            <ul className={`${blockName}__allies-list`}>
                {props.listaImagenes.map((img)=>{
                    return <li key={img.title}><img className={`${blockName}__image`} alt={img.title} src={img.file.url}></img></li>
                })}
            </ul>
        </section>
    );
};

export default AlliesLogos;